import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { TypeItem } from 'features/types/types/types.types'

type EditTypeVariables = {
	id: number
	data: Pick<TypeItem, 'name'>
}

type UseEditTypeMutationProps = {
	onSuccess: () => void
}

export const useEditTypeMutation = ({ onSuccess }: UseEditTypeMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editTypeMutation, isPending: isEditTypeLoading } = useMutation({
		mutationFn: ({ id, data }: EditTypeVariables) => {
			return axiosPrivate.patch(apiRoutes.type(String(id)), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.types.all })
			useToast({ type: 'success', message: t('Type edited') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editTypeMutation,
		isEditTypeLoading
	}
}
